module.exports = __webpack_public_path__ + "static/media/checkmark-circle-outlined.d9ffb22b.svg";